import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='bg-dark footer'>
        <hr style={{height:'1px',width:"100%",backgroundColor:'gray'}}></hr>
      <div className='d-flex justify-content-between p-3 flex-wrap'>
         <div className='footer_left'>
            <div className='ms-5'>
               <strong className='fs-5 text-white'>Quick Links</strong>
               <div className='d-flex flex-column gap-1 mt-2 ms-3'>
                  <span className='footer_ text-white'><Link to="https://www.nexonweb.com/about-us" className='text-decoration-none text-reset'>About Us</Link></span>
                  <span className='text-white'><Link to={'https://www.nexonweb.com/contact-us' } className='text-decoration-none text-reset'>Contact Us</Link></span>
                  <span className='text-white'><Link to={"https://www.nexonweb.com/blogs"} className='text-decoration-none text-reset'>Blogs</Link></span>
                  <span className='text-white'><Link to={"/privacy-policy"} className='text-decoration-none text-reset'>Privacy Policy</Link></span>
                  <span className='text-white'><Link to={"/terms-and-conditions"} className='text-decoration-none text-reset'>Terms & Conditions</Link></span>
               </div>
            </div>
            <div className='ms-5'>
               <strong className='fs-5 text-white'>Services</strong>
               <div className='d-flex flex-column gap-1 mt-2 ms-3'>
                  <span className='text-white'><Link to={'https://www.nexonweb.com/web-development'} className='text-decoration-none text-white'>Web Development</Link></span>
                  <span className='text-white'><Link to={'https://www.nexonweb.com/e-commerce-development'}  className='text-decoration-none text-white'>E-Commerce</Link></span>
                  <span className='text-white'><Link to={'https://www.nexonweb.com/mobile-app-development'} className='text-decoration-none text-white'>Mobile App Development</Link></span>
                  <span className='text-white'><Link to={'https://www.nexonweb.com/blockchain-development'} className='text-decoration-none text-white'>Blockchain Developement</Link></span>
                  <span className='text-white'><Link to={'https://www.nexonweb.com/digital-marketing'} className='text-decoration-none text-white'>Digital Marketing</Link></span>
               </div>
            </div>
         </div>
         <div className='footer_logo'>
            <div>
              <p className='text-white'>Designed & Developed By:</p>
              <Link to={'https://www.nexonweb.com/index'}><img src='/white_logo.png' height={"59px"} width={"150px"}/></Link>
            </div>
         </div>
      </div>
    </div>
  )
}

export default Footer
